
import { defineComponent } from 'vue';
import Modal from '@/components/info/Modal.vue';
import { getPayoutDescription, getPayoutName, PayoutCategory } from '@/lib/payout';

export default defineComponent({
  name: 'ExplainAll',
  props: {
    modelValue: {
      required: true,
    },
  },
  components: {
    Modal,
  },
  computed: {
    title(): string | null {
      return this.modelValue !== null ? getPayoutName(this.modelValue as PayoutCategory) : null;
    },

    description(): string[] | null {
      return this.modelValue !== null ? getPayoutDescription(this.modelValue as PayoutCategory) : null;
    },
  },
});
